export var ActionType = {
  VIEW: "view"
};